import { api } from '../configs/axiosConfigs';
import { CreateOffersInput, PreviewInput } from '../../utility/contractOffers';
import { unwrapBlobError } from '../../utility/blobErrors';

export const getContractOfferSetup = async () => api.get('/contract_offers/setup');

export const getContractOffers = async (listSortId: string) =>
  api.get('/contract_offers', { params: { list_sort_id: listSortId }, headers: { Accept: 'application/json' } });

// Generates and stores one contract per property (nothing is sent to anyone).
export const createContractOffers = async (input: CreateOffersInput) => api.post('/contract_offers', input);

// Returns the filled contract as a blob so it can be opened in a new tab (nothing is saved).
export const previewContractOffer = async (input: PreviewInput) => {
  try {
    return await api.post('/contract_offers/preview', input, { responseType: 'blob' });
  } catch (error) {
    throw await unwrapBlobError(error);
  }
};
